import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { Comment } from '../../../../providers/bridge-api/dashboard.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-comment-compact-card',
  imports: [AppSharedModule],
  templateUrl: './comment-compact-card.component.html',
  styleUrls: ['./comment-compact-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentCompactCardComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() comment: Comment;
  @Input() selected: boolean;
}
